import { CHANNELS, PRODUCTS } from "../lib/constants/appConstants";
import ROUTES from "../lib/constants/routes";
import { AlertConfig } from "../interfaces/Types";

export const ALERT_CONFIG: AlertConfig[] = [
  {
    product: PRODUCTS.VILLA,
    channel: CHANNELS.GJENSIDIGE,
    page: ROUTES.offerPage,
    alertTitle: "Fast pris i tre år",
    alertMessage: "Du behåller samma pris i tre år om du är skadefri.",
    startDate: "2023-05-22", // startDate and endDate are inclusive
    endDate: "2024-01-01",
  },
  {
    product: PRODUCTS.HOME,
    channel: CHANNELS.GJENSIDIGE,
    page: ROUTES.offerPage,
    alertTitle: "Fast pris i tre år",
    alertMessage: "Du behåller samma pris i tre år om du är skadefri.",
    startDate: "2023-05-22", // startDate and endDate are inclusive
    endDate: "2023-01-01",
  },
];
